import globalStyle from '@/styles/Global.scss'
import button from "bootstrap/js/src/button";

const FormSubmitButton = ({ value = '',
                   width = 120,
                   disabled = false,
                   color = 'white',
                   fontColor = '#0a58ca',
                   image = ''}) => {
  return (
    <>
      <button
        className={globalStyle.navigateButton}
        style={{ width: `${width}px` }}
        disabled={disabled}
      >
        {
          image !== '' && <>
            <img width={`${width}px`} src={`/button/${image}`}/>
          </>
        }
        {
          image === '' && <>
            <span style={{color: fontColor}}>{value}</span>
          </>
        }
      </button>
    </>
  )
}

export default FormSubmitButton;
